import type { ColumnPinningState } from "@tanstack/react-table";
import { t } from "ttag";

import type { LegacyDrill } from "metabase/visualizations/types";
import type { DatasetColumn } from "metabase-types/api";

const ROW_ID_COLUMN_ID = "row-id-column";

export const FreezeColumnAction: LegacyDrill = ({ question, clicked = {} }) => {
  if (
    !clicked ||
    clicked.value !== undefined ||
    !clicked.column ||
    question._card.display !== "table"
  ) {
    return [];
  }

  const { column } = clicked;

  const { handleFixedColumnClick, columnPinning, columnId } = clicked as {
    handleFixedColumnClick?: (column: DatasetColumn) => void;
    columnPinning?: ColumnPinningState;
    columnId?: string;
  };

  if (!handleFixedColumnClick || !columnId) {
    return [];
  }

  if (columnId === ROW_ID_COLUMN_ID) {
    return [];
  }

  const isPinned = columnPinning?.left?.includes(columnId) ?? false;

  const tooltip = isPinned ? t`Cancel Freeze` : t`Freeze Left`;
  const title = isPinned ? t`Unfreeze Column` : t`Freeze column`;

  return [
    {
      name: "fixed",
      title: title,
      section: "summarize",
      buttonType: "horizontal",
      icon: "pin",
      type: "custom" as const,
      defaultAlways: false,
      tooltip: tooltip,
      onClick: () => {
        handleFixedColumnClick(column);
      },
    },
  ];
};
